export default __webpack_public_path__ + "74b1f4abb0dcb0aecb2d04ee776c86df.png";